import { CACHE_SEARCH_CITY, GEO_CODE_SUCCESS } from './../actions/action_types';

export default (
  state = {
    cachedSearchCity: null,
  },
  action,
) => {
  switch (action.type) {
    case CACHE_SEARCH_CITY:
      return {
        ...state,
        cachedSearchCity: action.payload.city,
      };
    case GEO_CODE_SUCCESS:
      if (action.payload.shouldCache) {
        // todo
        return {
          ...state,
          cachedSearchCity: {
            name: action.payload.address,
            location: action.payload.poi.location,
          },
        };
      }
      return state;
    default:
      return state;
  }
};
